import { render, staticRenderFns } from "./saving.vue?vue&type=template&id=95cff630&scoped=true"
import script from "./saving.vue?vue&type=script&lang=js"
export * from "./saving.vue?vue&type=script&lang=js"
import style0 from "./saving.vue?vue&type=style&index=0&id=95cff630&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95cff630",
  null
  
)

export default component.exports